import type { ComponentStyleConfig } from '@chakra-ui/react';

const TextNoMargin: ComponentStyleConfig = {
  baseStyle: {
    margin: 0,
    marginBlockEnd: 0, // Reset paragraph's default bottom margin
    marginBlockStart: 0, // Reset paragraph's default top margin
    fontSize: { base: '15px', lg: '16px' },
    lineHeight: { base: '22px', lg: '24px' },
    color: 'gray.1002',
  },
  variants: {
    introHighlight: {
      fontSize: { base: '18px', md: '20px', lg: '20px' },
      lineHeight: { base: '24px', md: '26px', lg: '26px' },
      color: '#747474',
    },
  },
  defaultProps: {
    // Do NOT set variant here, or set to undefined/base
    // variant: undefined,
  },
};

export default TextNoMargin;
